<main>
  <header>
    <h1>Tell us about your business</h1>
    <p class="subtitle">Every business is unique. We want to learn about yours. Please provide accurate information as registered with IRS to ensure compliance.</p>
  </header>
  <form
    class="application-form"
    [formGroup]="form"
    (ngSubmit)="continue()"
    appPopulateForm
    [formType]="'aboutBusiness'"
    [form]="form"
    >
    <div class="field">
      <label for="businessLegalName">Legal Name</label>
      <mat-form-field appearance="outline" hideRequiredMarker>
        <input matInput formControlName="businessLegalName" required placeholder="Enter">
        @if (form.get('businessLegalName')?.hasError('required')) {
          <mat-error>
            Legal Name is required
          </mat-error>
        }
      </mat-form-field>
    </div>
    <div class="field">
      <label for="businessDBA">Doing Business As (if available)</label>
      <mat-form-field appearance="outline" hideRequiredMarker>
        <input matInput formControlName="businessDBA">
      </mat-form-field>
    </div>

    <!-- Removed as per product (TBYND-808) -->
    <!--
    <div class="field">
      <label for="businessEmail">Email</label>
      <mat-form-field appearance="outline" hideRequiredMarker>
        <input matInput formControlName="businessEmail" required placeholder="Enter">
        <mat-error *ngIf="form.get('businessEmail')?.hasError('required')">
          Email is required
        </mat-error>
        <mat-error *ngIf="form.get('businessEmail')?.hasError('email')">
          Please enter a valid email address
        </mat-error>
      </mat-form-field>
    </div>
    -->

    <div class="field">
      <label for="businessPhone">Phone</label>
      <mat-form-field appearance="outline" hideRequiredMarker>
        <input matInput formControlName="businessPhone" required type="tel" mask="(000) 000-0000" inputmode="numeric" placeholder="Enter">
        @if (form.get('businessPhone')?.hasError('required')) {
          <mat-error>
            Phone is required
          </mat-error>
        }
        @if (form.get('businessPhone')?.hasError('pattern')) {
          <mat-error>
            Phone must be exactly 10 digits
          </mat-error>
        }
        <mat-hint>Your contact number for business inquiries</mat-hint>
      </mat-form-field>
    </div>
    <div class="field">
      <label for="businessWebsite">Website</label>
      <mat-form-field appearance="outline" hideRequiredMarker>
        <input matInput formControlName="businessWebsite" placeholder="(optional)">
        @if (form.get('businessWebsite')?.hasError('pattern')) {
          <mat-error>
            Please enter a valid website URL
          </mat-error>
        }
        <mat-hint>Your official website address</mat-hint>
      </mat-form-field>
    </div>
    <app-form-actions
      [isFormInvalid]="form.invalid"
      (continue)="continue()"
      (back)="goBack()"
      >
    </app-form-actions>
  </form>
</main>
